// Module
var code = `<div class="row">
	<table class="table">
		<tr>
			<th>Date</th>
			<th>Installs</th>
			<th ng-repeat="step in steps_names" title="{{step.description}}">{{step.num}}</th>
		</tr>
		<tr style="background-color: #FFEBCD">
		    <td>Average</td>
		    <td>{{apply(data[0].Inst)}}</td>
		    <td ng-repeat="step in steps_names" title="{{step.description}}">{{apply(data[0][step.key])}}</td>
		</tr>
		<tr ng-repeat="day in data">
		    <td>{{day.Date}}</td>
		    <td>{{day.Inst}}</td>
		    <td ng-repeat="step in steps_names" title="{{step.description}}"
				ng-style="{'background-color': apply_color(day[step.key], step.key)}">{{apply(day[step.key])}}</td>
		</tr>
	</table>
</div>





`;
// Exports
module.exports = code;